import { render, staticRenderFns } from "./TestIndex.vue?vue&type=template&id=3c650aaf"
import script from "./TestIndex.vue?vue&type=script&lang=js"
export * from "./TestIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports